/* eslint-disable react-hooks/exhaustive-deps */
import {useCallback} from 'react'

import {atomButtonGroupPositions} from '@s-ui/react-atom-button'

const useButtonGroupFilter = ({allSelectionsLabel, options, value}) => {
  const getPositions = useCallback(() => {
    const hasAllSelectionsField = Boolean(allSelectionsLabel)
    return options.map((_, index) => {
      const isFirstOption = index === 0
      const isLastOption = index === options.length - 1
      if (isFirstOption && !hasAllSelectionsField) return atomButtonGroupPositions.FIRST
      if (isLastOption) return atomButtonGroupPositions.LAST
      return atomButtonGroupPositions.MIDDLE
    })
  }, [allSelectionsLabel, options, value])

  return {
    positions: getPositions()
  }
}

export default useButtonGroupFilter
